

























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import GeofenceModel from '@/_models/GeofenceModel'
import Multiselect from 'vue-multiselect'
import UserModel from '@/_models/UserModel'
import SwatcherBulma from '@/components/shared/SwatcherBulma.vue'
import MessageItem from '@/components/geofence_monitor/partials/MessageItem.vue'
// Const
import { GEOFENCE_ACTIONS } from '@/_consts/GeofenceAction'
import GeofenceMessage from '@/_interfaces/GeofenceMessage'

@Component({
  components: {
    Multiselect,
    SwatcherBulma,
    MessageItem,
  },
  computed: {},
})
export default class GeofenceAddEditModal extends Vue {
  // Props
  @Prop()
  data!: GeofenceModel

  viewBgCustom: boolean = false
  messageDataEx: GeofenceMessage = {
    _id: '2bfe1182-27c4-11eb-a8df-0242ac110004',
    u_name: 'Example User',
    geo_name: 'Geofence Name',
    measureded_at: new Date(),
  }

  get messageEnter(): GeofenceMessage {
    return {
      ...this.messageDataEx,
      is_enter: true,
      geo_bg_class: this.data.geofence_styles.bg_card_enter || 'success',
    }
  }

  get messageExit(): GeofenceMessage {
    return {
      ...this.messageDataEx,
      is_enter: false,
      geo_bg_class: this.data.geofence_styles.bg_card_exit || 'danger',
    }
  }

  get hasError(): boolean {
    return false
  }

  get getPlaceHolderText() {
    return `${this.$t('label.search_by_placeholder')}
    ${this.$t('label.username')}`
  }

  get users(): UserModel[] {
    return this.$store.state.users.all.items
  }

  get userFilter() {
    const usersMaper = this.users
      .filter((user) => user.san_id || (user.major && user.minor))
      .map((user: UserModel) => {
        const maper = {
          _id: user._id,
          name: user.name,
          type: user.hasOwnProperty('card_type') ? 'card' : 'beacon',
        }

        /* tslint:disable:no-string-literal */
        if (user.hasOwnProperty('card_type')) {
          maper['san_id'] = user.san_id
          maper['u_name'] = `[${user.san_id}] ${user.name}`
        } else {
          maper['ma'] = user.major
          maper['mi'] = user.minor
          maper['u_name'] = `[${user.major + '/' + user.minor}] ${user.name}`
        }
        return maper
      })

    return [
      {
        title: `${this.$t('all')} ${this.$t('label.user')}`,
        users: usersMaper,
      },
    ]
  }

  get userOptions() {
    return {
      selectLabel: `${this.$t('label.press_to_add')}`,
      deselectLabel: `${this.$t('label.press_to_remove')}`,
      selectedLabel: `${this.$t('label.press_to_remove')}`,
      multiple: true,
      taggable: false,
      tagPlaceholder: `${this.$t('label.placeholder_tag')}`,
      'group-values': 'users',
      'group-label': 'title',
      groupSelect: true,
      selectGroupLabel: `${this.$t('label.press_to_selectAll')}`,
      deselectGroupLabel: `${this.$t('label.press_to_unselectAll')}`,
      limit: 5,
    }
  }

  get actionOptions() {
    return {
      ...this.userOptions,
      'group-values': 'actions',
    }
  }

  get actionFilter() {
    return [
      {
        title: `${this.$t('all')}`,
        actions: GEOFENCE_ACTIONS,
      },
    ]
  }

  get buttonSaveText() {
    return this.data._id ? this.$t('button.save') : this.$t('button.register')
  }

  handleOpenModelAdjustMap() {
    this.$emit('openAdjustMapModal', true)
  }

  async doApplyChange() {
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return false
      }

      // return
      if (!this.data._id) {
        // Add one
        this.$store.dispatch('geofences/addOne', this.data).then(() => {
          this.$emit('isFormModalActive', false)
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store.dispatch('geofences/updateOne', this.data).then(() => {
          this.$emit('isFormModalActive', false)
          this.$buefy.toast.open(this.$t('messages.update_success') as string)
        })
      }
    })
  }

  async handleApplyChange() {
    this.doApplyChange()
  }
}
